import React from "react";
import { Tag } from "antd";
import { Locale, Util } from "../../utils";
import {
  getCommissionStatusColor,
  getPayoutModeColor,
  shouldShowShareableLimit,
} from "./commissionPayoutDisplay";

const i18n = Locale.getInstance();
const util = Util.getInstance();

function renderOtherPaymentInfo(record) {
  const info = record.other_payment_info;
  if (!info) {
    return null;
  }

  return (
    <div style={{ marginTop: 4, fontSize: 12, lineHeight: 1.5, color: "#8c8c8c" }}>
      <div>
        {i18n.t("commissionList.paidOtherWayPayType")}: {info.pay_type}
      </div>
      <div>
        {i18n.t("commissionList.paidOtherWayDate")}: {info.paid_at}
      </div>
      {info.evidence_image_url && (
        <div>
          <a href={info.evidence_image_url} target="_blank" rel="noreferrer">
            {i18n.t("commissionList.paidOtherWayEvidence")}
          </a>
        </div>
      )}
    </div>
  );
}

function renderShareableLimitInfo(record) {
  const info = record.shareable_limit_info;
  if (!info) {
    return null;
  }

  const ratioPercent = (info.shareable_ratio * 100).toFixed(1);

  return (
    <div style={{ marginTop: 4, fontSize: 12, lineHeight: 1.5, color: "#8c8c8c" }}>
      <div>
        {i18n.t("commissionList.shareableRealPayment", {
          amount: util.getFormattedPrice(info.real_payment, "¥"),
        })}
      </div>
      <div>
        {i18n.t("commissionList.shareableLimit", {
          ratio: ratioPercent,
          amount: util.getFormattedPrice(info.shareable_limit, "¥"),
        })}
      </div>
      <div>
        {i18n.t("commissionList.shareableOrderTotal", {
          amount: util.getFormattedPrice(info.order_commission_total, "¥"),
        })}
      </div>
      {info.exceeds_shareable_limit && (
        <div style={{ color: "#d46b08" }}>
          {i18n.t("commissionList.shareableExcess", {
            amount: util.getFormattedPrice(info.excess_amount, "¥"),
          })}
        </div>
      )}
    </div>
  );
}

export function CommissionPayoutModeTag({ record }) {
  const payout = record.payout_info;
  if (!payout || !payout.mode_label) {
    return null;
  }
  return <Tag color={getPayoutModeColor(payout.mode)}>{payout.mode_label}</Tag>;
}

export default function CommissionPayoutStatus({ record }) {
  const payout = record.payout_info;
  const label =
    payout && payout.display_label ? payout.display_label : record.status_label;

  return (
    <div>
      <Tag color={getCommissionStatusColor(record)}>{label}</Tag>
      {payout && payout.hint && (
        <div style={{ marginTop: 4, fontSize: 12, lineHeight: 1.5, color: "#8c8c8c" }}>
          {payout.hint}
        </div>
      )}
      {record.status === 7 && renderOtherPaymentInfo(record)}
      {shouldShowShareableLimit(record) && renderShareableLimitInfo(record)}
    </div>
  );
}
